import { createReducer, createActions } from "reduxsauce";
import update from "immutability-helper";
import { IState, ISuccessAction, IFailureAction } from "interfaces/update-duck";

const { Types, Creators } = createActions(
  {
    request: ["id", "putData", "onSuccess", "onFailure"],
    success: [],
    failure: ["error"],
    reset: [],
  },
  { prefix: "UPDATE_ZIPCODE_INTERNACIONAL_" }
);

export interface UpdateZipcodeInternacionalState extends IState {}

const INITIAL_STATE: UpdateZipcodeInternacionalState = {
  loading: false,
  error: null,
};

const request = (state: UpdateZipcodeInternacionalState) =>
  update(state, {
    loading: { $set: true },
    error: { $set: null },
  });

const success = (state: UpdateZipcodeInternacionalState, action: ISuccessAction) =>
  update(state, {
    loading: { $set: false },
  });

const failure = (state: UpdateZipcodeInternacionalState, action: IFailureAction) =>
  update(state, {
    loading: { $set: false },
    error: { $set: action.error },
  });

const reset = () => INITIAL_STATE;

export const updateZipcodeInternacional = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.RESET]: reset,
});

export const UpdateZipcodeInternacionalTypes = Types;
export const UpdateZipcodeInternacionalActions = Creators;
